<template>
  <v-row
    :class="baseClass"
    align="center"
    justify="center"
  >
    <v-progress-circular
      :size="90"
      :width="7"
      color="primary"
      :indeterminate="true"
    />
    <span style="font-size: 18px; font-weight: bold; margin-bottom: 14px; color: #143693"> {{ message }}</span>
  </v-row>
</template>
<script>
  export default {
    props: {
      message: {
        type: String,
        default: () => 'Aguarde...   Coletando informações do servidor.',
      },
      baseClass: {
        type: String,
        default: () => 'fill-height ma-5 pt-5 flex-column',
      },
    },
    data () {
      return {
        interval: {},
        value: 0,
        index: 0,
      }
    },
    computed: {

    },
    mounted () {
    },
    methods: {

    },
  }
</script>
